const locale = {
    translation: {
        
    }
}

export default locale
